import type { ReactNode } from 'react';
import { Button, type IButtonProps } from '~/components/ui';
import { Modal } from './Modal';

const stayOpen = () => undefined;

export type ConfirmDialogProps = Readonly<{
  isOpen: boolean;
  title: ReactNode;
  message: ReactNode;
  cancelLabel: string;
  confirmLabel: string;
  confirmVariant?: IButtonProps['variant'];
  isPending?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}>;

export function ConfirmDialog({
  isOpen,
  title,
  message,
  cancelLabel,
  confirmLabel,
  confirmVariant = 'destructive',
  isPending = false,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={isPending ? stayOpen : onCancel}>
      <div className="bg-neut-bg-alt rounded-lg p-6 w-full max-w-sm">
        <h2
          id="Modal-title"
          className="text-base font-semibold text-neut-prim mb-2"
        >
          {title}
        </h2>
        <p className="text-sm text-neut-sec mb-4">{message}</p>
        <div className="flex gap-3">
          <Button
            size="sm"
            variant="accent"
            onClick={onCancel}
            disabled={isPending}
          >
            {cancelLabel}
          </Button>
          <Button
            size="sm"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isPending}
            loading={isPending}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
